import { Link, useLocation } from "react-router-dom";
import * as LucideIcons from "lucide-react";

const Navigator = (props) => {
  const location = useLocation();
  const {
    name,
    path,
    path2,
    path3,
    iconName,
    onClick,
    children,
  } = props;

  const hasSubmenu = Boolean(children?.length);

  const isActiveMain =
    location.pathname === path ||
    location.pathname === path2 ||
    location.pathname === path3;
  const Icon = iconName && LucideIcons[iconName] ? LucideIcons[iconName] : null;

  return (
    <ul className="mainMenu">
      <li onClick={onClick} className={hasSubmenu ? "has-submenu" : ""}>
        <Link
          to={path || "#"}
          className={`menu-link ${isActiveMain ? "activeMenu no-hover" : ""}`}
        >
          <div className="activemenu d-flex align-items-center gap-1">
            {Icon && <Icon size={18} className="me-1 text-gray-700" />}
            <span className="normal-case">{name}</span>
          </div>
          {hasSubmenu && <i className="fa-solid fa-angle-right rightangel"></i>}
        </Link>

        {hasSubmenu && (
          <ul className="subMenu transform0">
            {children.map((child, index) => {
              const { subName, subIconName, subPath, subPath2, subPath3, onClick2 } =
                child?.props;
              const isActiveSub =
                location.pathname === subPath ||
                location.pathname === subPath2 ||
                location.pathname === subPath3;
              const SubIcon =
                subIconName && LucideIcons[subIconName]
                  ? LucideIcons[subIconName]
                  : null;

              return (
                <li key={index} onClick={onClick2}>
                  <Link
                    to={subPath}
                    className={`submenu-link ${isActiveSub ? "activeMenu no-hover" : ""}`}
                    title={subName}
                  >
                    {SubIcon && <SubIcon size={16} className="submenu-icon me-2" />}
                    <span>{subName}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    </ul>
  );
};

export default Navigator;
